module.exports = __webpack_public_path__ + "static/media/Fig-5-5.65f08b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-5-5.png
// module id = 711
// module chunks = 0